import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

type Props = {
  customMetricsField: React.ReactNode;
  adornment?: React.ReactNode;
};

export const WorkloadCustomMetricsSettingsContainer = ({
  customMetricsField,
  adornment,
}: Props) => {
  const { title, description } = vpaSettingsConstants.customMetrics;

  return (
    <VerticalSettingsForm
      title={title}
      description={description}
      titleAdornment={adornment}
    >
      {customMetricsField}
    </VerticalSettingsForm>
  );
};
